import {
  arrayToObjectAsync,
  getBaseProvidersData,
} from '../../contexts/main/getBaseProvidersData';
import { Pages } from '../../contexts/Location/LocationContext';
import { ControllerParams, CreateControllerFn } from '@wix/yoshi-flow-editor';
import { renderSeoMetatagsPage } from '../../services/SeoMetatagsPage';
import { getMyMember } from '@wix/ambassador-members-v1-member/http';
import { userProviderPropsMap } from '../../contexts/User/userProviderPropsMap';
import { getChallengeInitialData } from '../../contexts/storage-contexts/Challenge';
import { Referrer } from '../../contexts/storage/referrer';
import { getProgramSlug } from '../../selectors/getProgramSlug';
import { coupons } from './utils/coupons';
import { getTermsAndConditionsUrl } from './utils/getTermsAndConditionsUrl';
import {
  applyCouponToOrder,
  joinParticipant,
  removeCouponFromOrder,
} from '@wix/ambassador-challenges-v1-participant/http';
import { asyncControllerAmbassadorRequest } from '../../services/asyncController/asyncControllerAmbassadorRequest';
import { setControllerFlowApi } from '../../services/controllerProps/controllerProps';
import { defaultErrorOptions } from '../../utils/defaultErrorOptions';
import { createParticipantFlow } from './utils/createParticipantFlow';

const createController: CreateControllerFn = async ({
  flowAPI,
}: ControllerParams) => {
  setControllerFlowApi(flowAPI);
  const t = flowAPI.translations.t;
  return {
    async pageReady() {
      if (
        flowAPI.experiments.enabled(
          'spec.programs.CreateParticipantOnPaymentPage',
        )
      ) {
        return createParticipantFlow({
          flowAPI,
        });
      }

      const initialProps = {
        applyCouponToOrder: asyncControllerAmbassadorRequest(
          applyCouponToOrder,
          {
            errorCodesMap: {
              applicationError: {
                ERROR_COUPON_DOES_NOT_EXIST: () => {
                  return { message: t('coupons.form.error.doesnt-exist') };
                },
                payment_error: () => {
                  return { message: t('coupons.form.error.already-applied') };
                },
                ERROR_COUPON_IS_ALREADY_APPLIED: () => {
                  return {
                    message: t('coupons.form.error.already-applied'),
                  };
                },
              },
            },
          },
        ),
        getMyMember: asyncControllerAmbassadorRequest(
          getMyMember,
          defaultErrorOptions,
        ),
        removeCouponFromOrder: asyncControllerAmbassadorRequest(
          removeCouponFromOrder,
          defaultErrorOptions,
        ),
        joinParticipant: asyncControllerAmbassadorRequest(
          joinParticipant,
          defaultErrorOptions,
        ),
        ...(await arrayToObjectAsync([
          getBaseProvidersData({
            flowAPI,
          }),
          getChallengeInitialData(flowAPI, Referrer.PAYMENT_PAGE),
          userProviderPropsMap(flowAPI),
          coupons(flowAPI),
          getTermsAndConditionsUrl(flowAPI),
        ])),
      };

      if (!initialProps.participant && flowAPI.environment.isViewer) {
        const slug = getProgramSlug(initialProps?.challengeData?.challenge);
        initialProps.goToPage({
          pageId: Pages.Details,
          challengeId: slug,
        });
        return;
      }

      flowAPI.controllerConfig.setProps({ ...initialProps });

      renderSeoMetatagsPage(
        flowAPI,
        initialProps?.challengeData?.challenge,
        'PAYMENT_PAGE',
      );
    },
  };
};

export default createController;
